const QueryConstants = {
  ADD_A_FEED: 'addAFeed',
  ENCODED_ALIAS: 'encodedAlias',
  VERIFICATION_TOKEN: 'verificationToken',
  EMAIL_VERIFICATION: 'emailVerification',
  MARKETING_PATH: 'mktPath',
  POSTING_PATH: 'postingPath',
  SECURITY_TOKEN: 'securityToken',
  SIGN_IN_LP: 'signInLP',
  AD: 'ad',
  ARCHIVED: 'archived',
  HAS_SUCCESS_REDIRECT_PATH: 'hasSuccessRedirectPath',
  CLAIM_DASHBOARD: 'claimDashboard',
  REDIRECT_TO: 'redirectTo',
  SUB_NAV_FILTER_TYPE: 'subNavFilterType',
  SEARCH_TEXT: 'searchText',
  SCROLL_TO: 'scrollTo',
};

export const ACTIVATE_LISTING_MUTATION_KEY = ['activateListing'];

export default QueryConstants;
